import { SegmentedControl } from '@mantine/core';
import classes from './Tabs.module.css';

type Tab<T extends string> = {
  label: string;
  value: T;
};

type TabsProps<T extends string> = {
  value: T;
  onChange: (value: T) => void;
  tabs: Tab<T>[];
};

export function Tabs<T extends string>({ value, onChange, tabs }: TabsProps<T>) {
  return (
    <SegmentedControl
      value={value}
      onChange={v => onChange(v as T)}
      data={tabs}
      classNames={{ label: classes.label }}
      styles={{
        root: {
          borderRadius: 20,
          padding: 3,
          backgroundColor: 'var(--mantine-color-gray-2)',
        },
        label: {
          paddingLeft: 48,
          paddingRight: 48,
          paddingTop: 10,
          paddingBottom: 10,
          fontSize: 'var(--mantine-font-size-sm)',
          borderRadius: 16,
        },
        indicator: {
          borderRadius: 16,
          backgroundColor: 'var(--mantine-color-white)',
        },
      }}
    />
  );
}
